import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

// Legacy icon yet to be normalised to a 64 viewBox, ignoring rule for now.
// eslint-disable-next-line @pebblepad/icon-is-valid
export const crossIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M17.392 15.998 29.72 3.668a.983.983 0 1 0-1.39-1.39L16 14.606 3.67 2.278a.983.983 0 1 0-1.392 1.39l12.33 12.33L2.28 28.326a.985.985 0 0 0 1.392 1.392L16 17.388l12.328 12.33a.983.983 0 1 0 1.39-1.392z"/></svg>`
);
